export default __webpack_public_path__ + "static/media/14.8a045dce.mp3";